// Ancres de la homepage v2. La nav et les sections lisent ces valeurs : un test vérifie
// que chaque lien de la nav mène à une section réellement rendue.
export const SECTION_IDS = {
  why: "why",
  northos: "northos",
  deploy: "deploy",
  skills: "skills",
  contact: "contact",
} as const;

export const NAV_ITEMS = [
  { label: "Why Claude", id: SECTION_IDS.why },
  // v9 (Jérémy 18/09) : le lien s'appelait « OS ». Le produit s'appelle North OS partout ailleurs sur la page
  // (l'étiquette de la section, les cartes de la pile, la FAQ, le pied de page) : le menu le dit maintenant en entier.
  { label: "North OS", id: SECTION_IDS.northos },
  { label: "Deploy", id: SECTION_IDS.deploy },
  { label: "Skills", id: SECTION_IDS.skills },
] as const;
